export const UNITS = ['kg', 'g', 'L', 'mL', 'pcs', 'portion'] as const;
export type Unit = (typeof UNITS)[number];

export const SUPPLIER_CATEGORIES = [
  'vegetables',
  'wine',
  'milk',
  'drinks',
  'coffee',
  'food',
  'services',
  'cleaning',
  'packaging',
  'other',
] as const;
export type SupplierCategory = (typeof SUPPLIER_CATEGORIES)[number];
